import { Component } from '@angular/core';

import { take, takeUntil } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { SingleDetailComponent } from 'app/shared/components/single-detail/single-detail.component';
import { IContainerDetailsModel } from 'app/shared/models/container.models';
import { ContainerService } from 'app/shared/services/container.service';

import { ScannedDetailsComponentBase } from '../ScannedDetailsComponentBase';

@Component({
  selector: 'app-scanned-case-details',
  templateUrl: './scanned-case-details.component.html',
  styleUrls: ['./scanned-case-details.component.css'],
  standalone: true,
  imports: [SingleDetailComponent],
})
export class ScannedCaseDetailsComponent extends ScannedDetailsComponentBase {
  public containerDetails: IContainerDetailsModel;

  constructor(private containerService: ContainerService) {
    super();
  }

  handleCodeScanned(): void {
    this.containerService
      .getContainerSummaryByLabelCodeV1(this.labelCode.identifier)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (containerDetails: IContainerDetailsModel) => {
          this.containerDetails = containerDetails;
          this.navigationInstructions.emit(['/containers', containerDetails.id]);
        },
        error: (_error) => this.handleScanFail(),
      });
  }
}
